import React from 'react';
import { FileText, type LucideIcon } from 'lucide-react'; // Example icon, replace with dynamic icon prop
import Button from './Button';

interface ActionProps {
  label: string;
  onClick: () => void;
}

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description: string;
  action?: ActionProps;
}

/**
 * Reusable component to display an empty state for lists or data tables.
 */
const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon = FileText, // Default to FileText icon if not provided
  title,
  description,
  action,
}) => {
  return (
    <div className="text-center py-12 px-4 sm:px-6 lg:px-8">
      <Icon className="w-16 h-16 text-gray-400 mx-auto mb-4" />
      <h3 className="text-lg font-medium text-gray-900 mb-2">
        {title}
      </h3>
      <p className="text-sm text-gray-500 mb-6 max-w-md mx-auto">
        {description}
      </p>
      {action && (
        <Button onClick={action.onClick} variant="primary">
          {action.label}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;
